


if (!customElements.get('custom-related-products')) {
  customElements.define('custom-related-products', class RelatedProducts extends HTMLElement {
    constructor() {
      super();
      this.sectionSettings = JSON.parse(this.getAttribute("data-settings").replaceAll("/'", '"'));
      var relatedProductsSwiper = new Swiper(this.querySelector('.swiper-container'), {
        slidesPerView: 1.5,
        loop: false,
        // slidesPerGroup: 4,
        speed: 500,
        spaceBetween: 16,
        slidesOffsetBefore: 18,
        slidesOffsetAfter: 18,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        breakpoints: {
          480: {
            slidesOffsetBefore: 30,
            slidesOffsetAfter: 30,
          },
          590: {
            slidesPerView: 2.3,
            spaceBetween: 16,
            slidesOffsetBefore: 30,
            slidesOffsetAfter: 30,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            slidesPerGroup: 3,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 24,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            slidesPerGroup: 4,
          },
          1400: {
            slidesPerView: 5,
            spaceBetween: 24,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            slidesPerGroup: 5,
          },
        },
      });

    }

    connectedCallback() {
      if (this.sectionSettings.enable_auto_recommendations) {
        this.initRecommendations();
      }
    }

    initRecommendations() {
      const productId = this.getAttribute("data-product-id");
      const limit = this.sectionSettings.limit;

      const productsWrapper = this.querySelector("[data-swiper-wrapper]");
      const route = window.theme.routes.product_recommendations_url || '/recommendations/products/';
      const requestUrl = `${route}?section_id=related-products&limit=${limit}&product_id=${productId}`;

      themeVendor.axios
        .get(requestUrl)
        .then((response) => {
          const fresh = document.createElement('div');
          fresh.innerHTML = response.data;
          console.log(requestUrl, response, fresh,)

          const inner = fresh.querySelector('[data-swiper-wrapper]');
          const innerHtml = inner.innerHTML;

          productsWrapper.innerHTML = innerHtml;
        })
        .catch(function (error) {
          console.warn(error);
        });
    }
  });
}
